import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { axiosbaseurl } from "configure"
import moment from "moment"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"

const ClientContext = createContext()

export const useClientContext = () => {
  return useContext(ClientContext)
}

function getInitCISDate() {
  let cisdate = moment().date(5)
  if (cisdate.isBefore(moment())) cisdate.add(1, "months")
  return cisdate.format("YYYY-MM-DD")
}

const ClientContextBox = ({
  children,
  client_id,
  passClientName,
  isChanged,
  setIsChanged,
  changeStep,
  setHasPractice,
  setCType,
}) => {
  // step 1
  const [clientId, setClientId] = useState(null)

  const [clientType, setClientType] = useState(client_id ? 1 : "")
  const [clientName, setClientName] = useState("")
  const [clientCode, setClientCode] = useState("")
  const [haveTradingName, sethaveTradingName] = useState("no")
  const [tradingName, settradingName] = useState("")
  const [
    isRegisteredAddressAndCorrespondenceAddressSame,
    setisRegisteredAddressAndCorrespondenceAddressSame,
  ] = useState("yes")
  const [correspondenceAddress, setcorrespondenceAddress] = useState("")
  const [businessNature, setbusinessNature] = useState("")
  const [haveWebsite, sethaveWebsite] = useState("no")
  const [websiteLink, setwebsiteLink] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [houseNumber, setHouseNumber] = useState("")
  const [registeredAddress, setRegisteredAddress] = useState("")
  const [clientStatus, setClientStatus] = useState(null)
  const [connections, setConnections] = useState("")
  const [clientUnderPractice, setClientUnderPractice] = useState("")
  const [clientManager, setClientManager] = useState("")
  const [productionManager, setProductionManager] = useState("")
  const [assistant, setAssistant] = useState("")
  const [tradingStatus, setTradingStatus] = useState("")
  const [administrator, setAdministrator] = useState("")
  const [cisManager, setCisManager] = useState("")
  const [payrollManager, setPayrollManager] = useState("")

  const [doesBookkeeper, setDoesBookkeeper] = useState("no")
  const [bookkeeper, setBookkeeper] = useState(null)
  const [bookkeeping_system, setBookkeeping_system] = useState(null)
  const [xeroContactDetails, setXeroContactDetails] = useState({
    contactID: "N/A",
    firstName: "N/A",
    lastName: "N/A",
    name: "N/A",
    emailAddress: "N/A",
    contactStatus: "N/A",
    addresses: "N/A",
  })

  // primary contact details
  const [p_prefix, setPPrefix] = useState("")
  const [p_forename, setPForename] = useState("")
  const [p_surname, setPSurname] = useState("")
  const [p_email, setPEmail] = useState("")
  const [p_preferredName, setPPreferredName] = useState("")
  const [p_dob, setPDob] = useState("")
  const [p_occupation, setPOccupation] = useState("")
  const [p_mobile, setPMobile] = useState("")
  const [p_landline, setPLandline] = useState("")
  const [p_address1, setPAddress1] = useState("")
  const [p_address2, setPAddress2] = useState("")
  const [p_city, setPCity] = useState("")
  const [p_country, setPCountry] = useState("")
  const [p_postcode, setPPostcode] = useState("")
  const [p_contactDescription, setPContactDescription] = useState("")
  const [isPrimaryAbsence, setisPrimaryAbsence] = useState("no")

  // secondary contact details
  const [sameDetails, setSameDetails] = useState(false)
  const [s_prefix, setSPrefix] = useState("")
  const [s_forename, setSForename] = useState("")
  const [s_surname, setSSurname] = useState("")
  const [s_email, setSEmail] = useState("")
  const [s_preferredName, setSPreferredName] = useState("")
  const [s_dob, setSDob] = useState("")
  const [s_occupation, setSOccupation] = useState("")
  const [s_mobile, setSMobile] = useState("")
  const [s_landline, setSLandline] = useState("")
  const [s_address1, setSAddress1] = useState("")
  const [s_address2, setSAddress2] = useState("")
  const [s_city, setSCity] = useState("")
  const [s_country, setSCountry] = useState("")
  const [s_postcode, setSPostcode] = useState("")
  const [s_contactDescription, setSContactDescription] = useState("")

  // service & billing
  const [invoiceMethod, setInvoiceMethod] = useState("")
  const [paymentMethod, setPaymentMethod] = useState("")
  const [monthlyOverride, setMonthlyOverride] = useState("")
  const [servicesCalculation, setServicesCalculation] = useState([])
  const [tags, setTags] = useState([])

  // tax references
  const [utr, setUtr] = useState({
    number: "",
    status: "",
    letterLocation: "",
    isApplied: "no",
    appliedDate: "",
    follow_up_date: "",
    whyUTRNotApplicable: "",

    isAgentAuthorisationApplied: "",
    agentAuthorisationAppliedDate: "",
    agentAuthorisationStatus: "",
    authorisationCode: "",
    agentAuthorisationLetterLocation: "",
    agentAuthorisationNotAppliedReason: "",
  })
  const [pc, setPc] = useState({
    number: "",
    status: "",
    letterLocation: "",
    isApplied: "no",
    appliedDate: "",
    whyPersonalCodeNotApplicable: "",
  })
  const [cac, setCac] = useState({
    number: "",
    status: "",
    letterLocation: "",
    isApplied: "no",
    appliedDate: "",
    follow_up_date: "",

    isAgentAuthorisationApplied: "",
    agentAuthorisationAppliedDate: "",
    agentAuthorisationStatus: "",
    authorisationCode: "",
    agentAuthorisationLetterLocation: "",
    agentAuthorisationNotAppliedReason: "",
  })
  const [insurance, setInsurance] = useState({
    number: "",
    status: "",
    letterLocation: "",
    follow_up_date: "",
  })
  const [paye, setPaye] = useState({
    number: "",
    status: "",
    letterLocation: "",
    isApplied: "no",
    appliedDate: "",
    follow_up_date: "",
    officeReference: "",

    isAgentAuthorisationApplied: "",
    agentAuthorisationAppliedDate: "",
    agentAuthorisationStatus: "",
    authorisationCode: "",
    agentAuthorisationLetterLocation: "",
    agentAuthorisationNotAppliedReason: "",
  })
  const [vat, setVat] = useState({
    number: "",
    status: "",
    letterLocation: "",
    isApplied: "no",
    appliedDate: "",
    follow_up_date: "",

    isAgentAuthorisationApplied: "",
    agentAuthorisationAppliedDate: "",
    agentAuthorisationStatus: "",
    authorisationCode: "",
    agentAuthorisationLetterLocation: "",
    agentAuthorisationNotAppliedReason: "",
  })

  const [auditLogs, setAuditLogs] = useState([])

  const [officerIdStatus, setOfficerIdStatus] = useState("")
  const [officerId, setOfficerId] = useState("")

  const [
    accountsAndTaxCurrentYearDueDate,
    setAccountsAndTaxCurrentYearDueDate,
  ] = useState("2025-04-05")
  const [accountsAndTaxNextYearDueDate, setAccountsAndTaxNextYearDueDate] =
    useState("2025-04-05")

  const [currentMTDPeriodEnd, setCurrentMTDPeriodEnd] = useState(null)
  const [currentMTDPeriodDue, setCurrentMTDPeriodDue] = useState(null)

  const [VATFirstPeriod, setVATFirstPeriod] = useState("")
  const [VATFrequency, setVATFrequency] = useState("")
  const [VATCurrentPeriodEnd, setVATCurrentPeriodEnd] = useState("")
  const [VATCurrentPeriodDueDate, setVATCurrentPeriodDueDate] = useState("")
  const [isVatPresent, setVatPresent] = useState(false)

  const [CISDate, setCISDate] = useState(getInitCISDate())
  const [CISDueDate, setDueCISDate] = useState("")
  const [CISFrequency, setCISFrequency] = useState("")

  const [PAYEDate, setPAYEDate] = useState("")

  const [payrollWeeklyDate, setPayrollWeeklyDate] = useState("")
  const [payrollWeeklyDueDate, setPayrollWeeklyDueDate] = useState("")

  const [payrollFortNightlyDate, setPayrollFortNightlyDate] = useState("")
  const [payrollFortNightlyDueDate, setPayrollFortNightlyDueDate] = useState("")

  const [payrollForWeeklyDate, setPayrollForWeeklyDate] = useState("")
  const [payrollForWeeklyDueDate, setPayrollForWeeklyDueDate] = useState("")

  const [payrollMonthlyDate, setPayrollMonthlyDate] = useState("")
  const [payrollMonthlyDueDate, setPayrollMonthlyDueDate] = useState("")

  const [payrollFrequency, setpayrollFrequency] = useState([])

  const [bookkeepingFirstPeriodEnd, setBookkeepingFirstPeriodEnd] = useState("")
  const [bookkeepingFrequency, setBookkeepingFrequency] = useState("")
  const [bookkeepingCurrentPeriodEnd, setBookkeepingCurrentPeriodEnd] =
    useState("")
  const [bookkeepingCurrentPeriodDueDate, setBookkeepingCurrentPeriodDueDate] =
    useState("")
  const [isBookkeepingPresent, setBookkeepingPresent] = useState(false)

  const [managementAccountFirstPeriodEnd, setManagementAccountFirstPeriodEnd] =
    useState("")
  const [managementAccountFrequency, setManagementAccountFrequency] =
    useState("")
  const [
    managementAccountCurrentPeriodEndDate,
    setManagementAccountCurrentPeriodEndDate,
  ] = useState("")
  const [
    managementAccountCurrentPeriodDueDate,
    setManagementAccountCurrentPeriodDueDate,
  ] = useState("")
  const [isMAPresent, setMAPresent] = useState(false)

  const [confirmCurrentYearDueDate, setConfirmCurrentYearDueDate] =
    useState("2025-04-05")
  const [confirmCSYearDueDate, setConfirmCSYearDueDate] = useState("2025-04-05")
  const [currentKyc, setCurrentKyc] = useState("2025-12-03")
  const [kycDuration, setKycDuration] = useState("")
  const [nextKyc, setNextKyc] = useState("2026-12-03")

  // dynamic dropdowns
  const [client_type_options, setclient_type_options] = useState([])
  const [client_status_options, setclient_status_options] = useState([])
  const [connection_options, setconnection_options] = useState(null)
  const [allConnectionClients, setAllConnectionClients] = useState([])
  const [practice_options, setpractice_options] = useState([])
  const [staff_options, setstaff_options] = useState([])
  const [bookkeeper_options, setbookkeeper_options] = useState([])
  const [bookkeeping_options, setbookkeeping_options] = useState([])
  const [invoicing_options, setinvoicing_options] = useState([])
  const [payment_options, setpayment_options] = useState([])
  const [prefix_options, setprefix_options] = useState([])
  const [payroll_freq_options, setpayroll_freq_options] = useState([])
  const [account_freq_options, setaccount_freq_options] = useState([])
  const [vat_period_options, setvat_period_options] = useState([])

  const [static_frequency, setstatic_frequency] = useState([
    {
      label: "Monthly",
      value: "monthly",
    },
    {
      label: "Quarterly",
      value: "quarterly",
    },
    {
      label: "Annually",
      value: "annually",
    },
  ])

  // =======================
  // permissions Access
  const { checkAccess } = usePermissionData()
  const module_id = 1

  const isReadOnly =
    checkAccess(module_id, "view") &&
    !checkAccess(module_id, "edit") &&
    client_id

  const [loading, setLoading] = useState(false)

  const [errors, setErrors] = useState("")
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const isMounted = useRef(false)

  useEffect(() => setCType(clientType), [clientType])

  // getting dropdown options
  useEffect(() => {
    ;(async () => {
      try {
        const [
          connectedClients,
          serviceMaster,
          serviceTags,
          clientTypes,
          clientStatuses,
          practices,
          employees,
          bookkeepers,
          bookkeepingSystems,
          invoicingMethods,
          paymentMethods,
          prefixes,
          payrollFrequencies,
        ] = await Promise.allSettled([
          getOptions("connected-client"),
          client_id ? Promise.resolve(null) : getOptions("service-master"),
          getOptions("service/tags"),
          getOptions("client-type"),
          getOptions("client-status"),
          getOptions("practice-master"),
          getOptions("employee-master"),
          getOptions("bookkeeper"),
          getOptions("bookkeeping-system"),
          getOptions("invoicing-method"),
          getOptions("payment-method"),
          getOptions("prefix-master"),
          getOptions("payroll-frequency"),
        ])

        // helper to safely get value from settled result
        const val = result =>
          result.status === "fulfilled" ? result.value : null

        const connOptions = val(connectedClients)
        setconnection_options(
          connOptions?.map(c => ({ label: c.connectionName, value: c.id })) ||
            []
        )
        setAllConnectionClients(connOptions || [])

        const serviceOptions = val(serviceMaster)
        if (!client_id && serviceOptions) {
          setServicesCalculation(setServicesData(serviceOptions))
        }

        const tagsData = val(serviceTags)
        if (tagsData) {
          setTags(
            tagsData.map(tag => ({
              label: tag.tagName,
              value: tag.id,
              serviceIds: tag.serviceIds,
            }))
          )
        }

        if (val(clientTypes)) setclient_type_options(val(clientTypes))
        if (val(clientStatuses)) setclient_status_options(val(clientStatuses))
        if (val(practices)) setpractice_options(val(practices))
        if (val(employees)) setstaff_options(val(employees))
        if (val(bookkeepers)) setbookkeeper_options(val(bookkeepers))
        if (val(bookkeepingSystems))
          setbookkeeping_options(val(bookkeepingSystems))
        if (val(invoicingMethods)) setinvoicing_options(val(invoicingMethods))
        if (val(paymentMethods)) setpayment_options(val(paymentMethods))
        if (val(prefixes)) setprefix_options(val(prefixes))

        const payrollFreqData = val(payrollFrequencies)
        if (payrollFreqData) {
          setpayroll_freq_options(
            payrollFreqData.map(p => ({
              value: p.payrollFrequency,
              label: p.payrollFrequency,
            }))
          )
        }
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  // maintain to remind unsaved changes
  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[0]) {
      setIsChanged(prev => ({ ...prev, 0: true }))
    }
  }, [
    clientType,
    clientName,
    clientCode,
    email,
    houseNumber,
    registeredAddress,
    clientStatus,
    doesBookkeeper,
    bookkeeper,
    bookkeeping_system,
    haveTradingName,
    tradingName,
    isRegisteredAddressAndCorrespondenceAddressSame,
    correspondenceAddress,
    businessNature,
    haveWebsite,
    websiteLink,
  ])

  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[1]) {
      setIsChanged(prev => ({ ...prev, 1: true }))
    }
  }, [
    p_prefix,
    p_forename,
    p_surname,
    p_email,
    p_preferredName,
    p_dob,
    p_occupation,
    p_mobile,
    p_landline,
    p_address1,
    p_address2,
    p_city,
    p_country,
    p_postcode,
    p_contactDescription,
    isPrimaryAbsence,
    sameDetails,
    s_prefix,
    s_forename,
    s_surname,
    s_email,
    s_preferredName,
    s_dob,
    s_occupation,
    s_mobile,
    s_landline,
    s_address1,
    s_address2,
    s_city,
    s_country,
    s_postcode,
    s_contactDescription,
  ])

  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[2]) {
      setIsChanged(prev => ({ ...prev, 2: true }))
    }
  }, [invoiceMethod, paymentMethod, monthlyOverride, servicesCalculation])

  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[3]) {
      setIsChanged(prev => ({ ...prev, 3: true }))
    }
  }, [
    utr,
    pc,
    cac,
    insurance,
    paye,
    vat,
    VATFirstPeriod,
    VATFrequency,
    VATCurrentPeriodEnd,
    VATCurrentPeriodDueDate,
    payrollWeeklyDate,
    payrollWeeklyDueDate,
    payrollFortNightlyDate,
    payrollFortNightlyDueDate,
    payrollForWeeklyDate,
    payrollForWeeklyDueDate,
    payrollMonthlyDate,
    payrollMonthlyDueDate,
    payrollFrequency,
    currentMTDPeriodEnd,
    currentMTDPeriodDue,
    officerIdStatus,
    officerId,
  ])

  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[4]) {
      setIsChanged(prev => ({ ...prev, 4: true }))
    }
  }, [
    bookkeepingFirstPeriodEnd,
    bookkeepingFrequency,
    bookkeepingCurrentPeriodEnd,
    bookkeepingCurrentPeriodDueDate,
    managementAccountFirstPeriodEnd,
    managementAccountFrequency,
    managementAccountCurrentPeriodEndDate,
    managementAccountCurrentPeriodDueDate,
    kycDuration,
  ])

  useEffect(() => {
    if (!isMounted.current) return
    if (!isChanged[5]) {
      setIsChanged(prev => ({ ...prev, 5: true }))
    }
  }, [
    clientUnderPractice,
    clientManager,
    productionManager,
    assistant,
    administrator,
    cisManager,
    payrollManager,
  ])

  // getting dropdown options common function
  async function getOptions(api) {
    try {
      const response = await axiosbaseurl.get(`/${api}/active`)
      if (response.data.success) return response.data.data

      return false
    } catch (error) {
      console.log(error)
    }
  }

  // get cleint details
  useEffect(() => {
    if (client_id && connection_options) {
      ;(async () => {
        setLoading(true)
        try {
          //
          const options = await getOptions("service-master")
          const services_data = setServicesData(options)

          const response = await axiosbaseurl.get(`/client/${client_id}`)
          const { data, auditLogs } = response.data
          if (response.data.success) {
            if (!data?.hasPractice) {
              setHasPractice(false)
              changeStep(5)
            }

            setClientType(data?.clientTypeId)
            setClientName(data?.clientName)

            // pass to index.js
            passClientName(data?.clientName)
            // ====

            setClientCode(data?.clientCode)

            // getting xero contact details
            getXeroDetails(data?.clientCode)
            // =============================

            setEmail(data?.email)
            // setPassword(data?.password)
            setHouseNumber(data?.companyHouseNumber)
            setRegisteredAddress(data?.registeredAddress)
            setClientStatus(data?.clientStatusId)

            sethaveTradingName(data?.haveTradingName)
            settradingName(data?.tradingName)
            setisRegisteredAddressAndCorrespondenceAddressSame(
              data?.isRegisteredAddressAndCorrespondenceAddressSame
            )
            setcorrespondenceAddress(data?.correspondenceAddress)
            setbusinessNature(data?.businessNature)
            sethaveWebsite(data?.haveWebsite)
            setwebsiteLink(data?.websiteLink)

            const tempConn = connection_options?.filter(c =>
              JSON.parse(data?.connectionId)?.includes(c.value)
            )
            setConnections(tempConn)

            setClientUnderPractice(data?.clientUnderPracticeId)

            setTradingStatus(data?.trading)

            setClientManager(data?.clientManagerId)
            setProductionManager(data?.productionManagerId)
            setAssistant(data?.assistantId)
            setAdministrator(data?.administratorId)
            setCisManager(data?.CISManagerId)
            setPayrollManager(data?.payrollManagerId)
            setDoesBookkeeper(data?.haveBookeeper)
            setBookkeeper(data?.bookeeperId)
            setBookkeeping_system(data?.bookeepingSystemId)
            setPPrefix(data?.primaryPrefixId)
            setPForename(data?.primaryForename)
            setPSurname(data?.primarySurname)
            setPPreferredName(data?.primaryPreferredName)
            setPEmail(data?.primaryEmail)

            setPDob(
              data?.primaryDOB
                ? moment(data?.primaryDOB).format("YYYY-MM-DD")
                : null
            )

            setPOccupation(data?.primaryOccupation)
            setPMobile(data?.primaryMobile)
            setPLandline(data?.primaryLandline)
            setPAddress1(data?.primaryAddressLine1)
            setPAddress2(data?.primaryAddressLine2)
            setPCountry(data?.primaryCountry)
            if (data?.primaryCity && data?.primaryCountry == "Non-UK") {
              setPCity(data?.primaryCity)
            } else if (data?.primaryCity) {
              setPCity({ label: data?.primaryCity, value: data?.primaryCity })
            }
            setPPostcode(data?.primaryPostcode)
            setPContactDescription(data?.primaryContactDescription)

            setisPrimaryAbsence(data?.haveSecondaryContact)
            setSameDetails(data?.sameAsPrimaryDetails ? true : false)

            setSPrefix(data?.secondaryPrefixId)
            setSForename(data?.secondaryForename)
            setSSurname(data?.secondarySurname)
            setSPreferredName(data?.secondaryPreferredName)
            setSEmail(data?.secondaryEmail)
            setSDob(
              data?.secondaryDOB
                ? moment(data?.secondaryDOB).format("YYYY-MM-DD")
                : null
            )
            setSOccupation(data?.secondaryOccupation)
            setSMobile(data?.secondaryMobile)
            setSLandline(data?.secondaryLandline)
            setSAddress1(data?.secondaryAddressLine1)
            setSAddress2(data?.secondaryAddressLine2)
            setSCountry(data?.secondaryCountry)

            if (data?.secondaryCity && data?.secondaryCountry == "Non-UK") {
              setSCity(data?.secondaryCity)
            } else if (data?.secondaryCity) {
              setSCity({
                label: data?.secondaryCity,
                value: data?.secondaryCity,
              })
            }

            setSPostcode(data?.secondaryPostcode)
            setSContactDescription(data?.secondaryContactDescription)

            setInvoiceMethod(data?.invoicingMethodId)
            setPaymentMethod(data?.paymentMethodId)

            if (data?.serviceNameId) {
              const allServices =
                JSON?.parse(JSON.parse(data?.serviceNameId)) || []
              const newServices = services_data?.map(item => {
                if (allServices?.some(i => i.id === item.id)) {
                  return {
                    ...allServices?.find(i => i.id === item.id),
                    category: item.category,
                  }
                } else return item
              })
              setServicesCalculation(newServices)
            } else {
              setServicesCalculation(services_data)
            }

            setMonthlyOverride(data?.monthlyOverride)

            setUtr({
              number: data?.UTRNumber,
              status: data?.UTRStatus,
              letterLocation: data?.letterLocationUTR,
              isApplied: data?.isUTRApplied,
              appliedDate: moment
                .utc(data?.UTRAppliedDate)
                ?.format("YYYY-MM-DD"),
              follow_up_date: moment
                .utc(data?.UTRStatusChangeDate)
                ?.format("YYYY-MM-DD"),
              whyUTRNotApplicable: data.whyUTRNotApplicable,
              isAgentAuthorisationApplied: data?.isUTRAgentAuthorisationApplied,
              agentAuthorisationAppliedDate:
                data?.UTRAgentAuthorisationAppliedDate,
              agentAuthorisationStatus: data?.UTRAgentAuthorisationStatus,
              authorisationCode: data?.UTRAuthorisationCode,
              agentAuthorisationLetterLocation:
                data?.UTRAgentAuthorisationLetterLocation,
              agentAuthorisationNotAppliedReason:
                data?.UTRAgentAuthorisationNotAppliedReason,
            })
            setPc({
              number: data?.personalCode,
              status: data?.personalCodeStatus,
              letterLocation: data?.letterLocationPersonalCode,
              isApplied: data?.isPersonalCodeApplied,
              appliedDate: moment
                .utc(data?.personalCodeAppliedDate)
                ?.format("YYYY-MM-DD"),
              whyPersonalCodeNotApplicable: data.whyPersonalCodeNotApplicable,
            })
            setCac({
              number: data?.CACNumber,
              status: data?.CACStatus,
              letterLocation: data?.letterLocationCAC,
              isApplied: data?.isCACApplied,
              appliedDate: moment
                .utc(data?.CACAppliedDate)
                ?.format("YYYY-MM-DD"),
              follow_up_date: moment
                .utc(data?.CACStatusChangeDate)
                ?.format("YYYY-MM-DD"),

              isAgentAuthorisationApplied: data?.isCACAgentAuthorisationApplied,
              agentAuthorisationAppliedDate:
                data?.CACAgentAuthorisationAppliedDate,
              agentAuthorisationStatus: data?.CACAgentAuthorisationStatus,
              authorisationCode: data?.CACAuthorisationCode,
              agentAuthorisationLetterLocation:
                data?.CACAgentAuthorisationLetterLocation,
              agentAuthorisationNotAppliedReason:
                data?.CACAgentAuthorisationNotAppliedReason,
            })

            setInsurance({
              number: data?.insuranceNumber,
              status: data?.insuranceStatus,
              letterLocation: data?.letterLocationInsurance,
              follow_up_date: moment
                .utc(data?.InsuranceStatusChangeDate)
                ?.format("YYYY-MM-DD"),
            })

            setPaye({
              number: data?.PAYENumber,
              status: data?.PAYEStatus,
              letterLocation: data?.letterLocationPAYE,
              officeReference: data?.officeReferencePAYE,
              isApplied: data?.isPAYEApplied,
              appliedDate: moment
                .utc(data?.PAYEAppliedDate)
                ?.format("YYYY-MM-DD"),
              follow_up_date: moment
                .utc(data?.PAYEStatusChangeDate)
                ?.format("YYYY-MM-DD"),

              isAgentAuthorisationApplied:
                data?.isPAYEAgentAuthorisationApplied,
              agentAuthorisationAppliedDate:
                data?.PAYEAgentAuthorisationAppliedDate,
              agentAuthorisationStatus: data?.PAYEAgentAuthorisationStatus,
              authorisationCode: data?.PAYEAuthorisationCode,
              agentAuthorisationLetterLocation:
                data?.PAYEAgentAuthorisationLetterLocation,
              agentAuthorisationNotAppliedReason:
                data?.PAYEAgentAuthorisationNotAppliedReason,
            })
            setVat({
              number: data?.VATNumber,
              status: data?.VATStatus,
              letterLocation: data?.letterLocationVAT,
              isApplied: data?.isVATApplied,
              appliedDate: moment
                .utc(data?.VATAppliedDate)
                ?.format("YYYY-MM-DD"),
              follow_up_date: moment
                .utc(data?.VATStatusChangeDate)
                ?.format("YYYY-MM-DD"),

              isAgentAuthorisationApplied: data?.isVATAgentAuthorisationApplied,
              agentAuthorisationAppliedDate:
                data?.VATAgentAuthorisationAppliedDate,
              agentAuthorisationStatus: data?.VATAgentAuthorisationStatus,
              authorisationCode: data?.VATAuthorisationCode,
              agentAuthorisationLetterLocation:
                data?.VATAgentAuthorisationLetterLocation,
              agentAuthorisationNotAppliedReason:
                data?.VATAgentAuthorisationNotAppliedReason,
            })

            setAuditLogs(auditLogs)

            if (data?.officerIdStatus) setOfficerIdStatus(data?.officerIdStatus)
            if (data?.officerId) setOfficerId(data?.officerId)

            if (data?.accountsAndTaxCurrentYearDueDate)
              setAccountsAndTaxCurrentYearDueDate(
                moment
                  .utc(data?.accountsAndTaxCurrentYearDueDate)
                  ?.format("YYYY-MM-DD")
              )

            if (data?.accountsAndTaxNextYearDueDate)
              setAccountsAndTaxNextYearDueDate(
                moment
                  .utc(data?.accountsAndTaxNextYearDueDate)
                  ?.format("YYYY-MM-DD")
              )

            if (data?.currentMTDPeriodEnd)
              setCurrentMTDPeriodEnd(
                moment.utc(data?.currentMTDPeriodEnd)?.format("YYYY-MM-DD")
              )

            if (data?.currentMTDPeriodDue)
              setCurrentMTDPeriodDue(
                moment.utc(data?.currentMTDPeriodDue)?.format("YYYY-MM-DD")
              )

            if (data?.VATFirstPeriod)
              setVATFirstPeriod(
                moment(data?.VATFirstPeriod).format("YYYY-MM-DD")
              )

            if (data?.VATFrequency) setVATFrequency(data?.VATFrequency)

            if (data?.VATCurrentPeriodEnd)
              setVATCurrentPeriodEnd(
                moment.utc(data?.VATCurrentPeriodEnd).format("YYYY-MM-DD")
              )

            if (data?.VATCurrentPeriodDueDate) {
              setVatPresent(true)
              setVATCurrentPeriodDueDate(
                moment.utc(data?.VATCurrentPeriodDueDate).format("YYYY-MM-DD")
              )
            }

            if (data?.CISDate)
              setCISDate(moment.utc(data?.CISDate).format("YYYY-MM-DD"))

            if (data?.CISDate)
              setDueCISDate(moment.utc(data?.CISDueDate).format("YYYY-MM-DD"))

            setCISFrequency(data?.CISFrequency)

            if (data?.PAYEDate)
              setPAYEDate(moment(data?.PAYEDate)?.format("YYYY-MM-DD"))

            // ============================================================

            if (data?.payrollFrequency)
              setpayrollFrequency(
                JSON.parse(data?.payrollFrequency || "[]")?.map(p => ({
                  value: p,
                  label: p,
                }))
              )

            if (data?.payrollFirstWeeklyDate)
              setPayrollWeeklyDate(
                moment(data?.payrollFirstWeeklyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollSecondWeeklyDate)
              setPayrollWeeklyDueDate(
                moment(data?.payrollSecondWeeklyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollFirstMonthlyDate)
              setPayrollMonthlyDate(
                moment(data?.payrollFirstMonthlyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollSecondMonthlyDate)
              setPayrollMonthlyDueDate(
                moment(data?.payrollSecondMonthlyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollFirstFourWeeklyDate)
              setPayrollForWeeklyDate(
                moment(data?.payrollFirstFourWeeklyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollSecondFourWeeklyDate)
              setPayrollForWeeklyDueDate(
                moment(data?.payrollSecondFourWeeklyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollFirstFortNightlyDate)
              setPayrollFortNightlyDate(
                moment(data?.payrollFirstFortNightlyDate).format("YYYY-MM-DD")
              )

            if (data?.payrollSecondFortNightlyDate)
              setPayrollFortNightlyDueDate(
                moment(data?.payrollSecondFortNightlyDate).format("YYYY-MM-DD")
              )

            // ========================================================================================
            if (data?.bookkeepingFirstPeriodEnd) {
              setBookkeepingPresent(true)
              setBookkeepingFirstPeriodEnd(
                moment(data?.bookkeepingFirstPeriodEnd).format("YYYY-MM-DD")
              )
            }

            setBookkeepingFrequency(data?.bookkeepingFrequency)

            if (data?.bookkeepingCurrentPeriodEnd)
              setBookkeepingCurrentPeriodEnd(
                moment
                  .utc(data?.bookkeepingCurrentPeriodEnd)
                  .format("YYYY-MM-DD")
              )

            if (data?.bookkeepingCurrentPeriodDueDate)
              setBookkeepingCurrentPeriodDueDate(
                moment
                  .utc(data?.bookkeepingCurrentPeriodDueDate)
                  .format("YYYY-MM-DD")
              )

            if (data?.managementAccountFirstPeriodEnd) {
              setMAPresent(true)
              setManagementAccountFirstPeriodEnd(
                moment(data?.managementAccountFirstPeriodEnd).format(
                  "YYYY-MM-DD"
                )
              )
            }

            setManagementAccountFrequency(data?.managementAccountFrequency)

            if (data?.managementAccountCurrentPeriodEndDate)
              setManagementAccountCurrentPeriodEndDate(
                moment
                  .utc(data?.managementAccountCurrentPeriodEndDate)
                  .format("YYYY-MM-DD")
              )

            if (data?.managementAccountCurrentPeriodDueDate)
              setManagementAccountCurrentPeriodDueDate(
                moment
                  .utc(data?.managementAccountCurrentPeriodDueDate)
                  .format("YYYY-MM-DD")
              )

            if (data?.CScurrentYearDueDate)
              setConfirmCurrentYearDueDate(
                moment.utc(data?.CScurrentYearDueDate).format("YYYY-MM-DD")
              )
            if (data?.currentCSYearDueDate)
              setConfirmCSYearDueDate(
                moment.utc(data?.currentCSYearDueDate).format("YYYY-MM-DD")
              )
            if (data?.currentKYCDueDate)
              setCurrentKyc(
                moment(data?.currentKYCDueDate).format("YYYY-MM-DD")
              )
            if (data?.KYCFrequency) setKycDuration(data?.KYCFrequency)

            if (data?.nextKYCDueDate)
              setNextKyc(moment.utc(data?.nextKYCDueDate).format("YYYY-MM-DD"))
            setTimeout(() => {
              setIsChanged({
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false,
              })
              setIsDataLoaded(true)
            }, 1000)
          }
        } catch (error) {
          console.log(error)
        } finally {
          setLoading(false)
        }
      })()
    } else {
      setIsChanged({
        0: false, // client details
        1: false, // personal
        2: false, // service & billing
        3: false, // tax reference
        4: false, // Bookkeeping
        5: false, // Practice responsibility
      })
      setIsDataLoaded(true)
    }
  }, [client_id, connection_options])
  // ===================

  function getXeroDetails(clientCode) {
    axiosbaseurl
      .get(`/xero/contact/details/${clientCode}`)
      .then(res => {
        if (res.data.success) {
          const {
            contactID,
            firstName,
            lastName,
            name,
            emailAddress,
            addresses,
            contactStatus,
          } = res.data.data?.contacts[0]

          setXeroContactDetails({
            contactID: contactID || "--",
            firstName: firstName || "--",
            lastName: lastName || "--",
            name: name || "--",
            emailAddress: emailAddress || "--",
            contactStatus: contactStatus || "--",
            addresses:
              addresses.length > 0
                ? `${addresses[0]?.addressLine1} ${addresses[0]?.addressLine2}, ${addresses[0]?.city}, ${addresses[0]?.postalCode}`
                : "--",
          })
        }
      })
      .catch(err => [console.log(err)])
  }
  // console.log(servicesCalculation)
  function setServicesData(options = []) {
    // console.log(options)
    const newData = options.map(item => ({
      id: item.id,
      name: item.serviceName,
      isChecked: false,
      price: 0,
      discount: 0,
      total: 0,
      clientType: Number(item.clientTypeId),
      category: item?.serviceCategory,
    }))

    return (
      newData
        // for demo
        .filter(
          service =>
            service.category &&
            service.category !== "Non-Billiable and scheduled" &&
            service.category !== "Non-Billiable and Non-scheduled"
        )
    )
  }

  useEffect(() => {
    isMounted.current = true
  }, [])

  return (
    <ClientContext.Provider
      value={{
        isDataLoaded,

        errors,
        setErrors,
        xeroContactDetails,
        isReadOnly,
        // dropdown options
        client_type_options,
        client_status_options,
        connection_options,
        allConnectionClients,
        practice_options,
        staff_options,
        bookkeeper_options,
        bookkeeping_options,
        invoicing_options,
        payment_options,
        vat_period_options,
        payroll_freq_options,
        account_freq_options,
        prefix_options,
        static_frequency,
        // ===============

        clientId,
        setClientId,
        // for edit taking from params
        client_id,
        //
        clientType,
        setClientType,
        clientName,
        setClientName,
        clientCode,
        setClientCode,
        email,
        setEmail,

        haveTradingName,
        sethaveTradingName,
        tradingName,
        settradingName,
        isRegisteredAddressAndCorrespondenceAddressSame,
        setisRegisteredAddressAndCorrespondenceAddressSame,
        correspondenceAddress,
        setcorrespondenceAddress,
        businessNature,
        setbusinessNature,
        haveWebsite,
        sethaveWebsite,
        websiteLink,
        setwebsiteLink,

        password,
        setPassword,
        houseNumber,
        setHouseNumber,
        registeredAddress,
        setRegisteredAddress,
        clientStatus,
        setClientStatus,
        connections,
        setConnections,
        clientUnderPractice,
        setClientUnderPractice,
        tradingStatus,
        setTradingStatus,
        clientManager,
        setClientManager,
        productionManager,
        setProductionManager,
        assistant,
        setAssistant,
        administrator,
        setAdministrator,
        cisManager,
        setCisManager,
        payrollManager,
        setPayrollManager,
        doesBookkeeper,
        setDoesBookkeeper,
        bookkeeper,
        setBookkeeper,
        bookkeeping_system,
        setBookkeeping_system,

        // contact details
        p_prefix,
        setPPrefix,
        p_forename,
        setPForename,
        p_surname,
        setPSurname,
        p_email,
        setPEmail,
        p_preferredName,
        setPPreferredName,
        p_dob,
        setPDob,
        p_occupation,
        setPOccupation,
        p_mobile,
        setPMobile,
        p_landline,
        setPLandline,
        p_address1,
        setPAddress1,
        p_address2,
        setPAddress2,
        p_city,
        setPCity,
        p_country,
        setPCountry,
        p_postcode,
        setPPostcode,
        p_contactDescription,
        setPContactDescription,
        isPrimaryAbsence,
        setisPrimaryAbsence,
        sameDetails,
        setSameDetails,

        s_prefix,
        setSPrefix,
        s_forename,
        setSForename,
        s_surname,
        setSSurname,
        s_email,
        setSEmail,
        s_preferredName,
        setSPreferredName,
        s_dob,
        setSDob,
        s_occupation,
        setSOccupation,
        s_mobile,
        setSMobile,
        s_landline,
        setSLandline,
        s_address1,
        setSAddress1,
        s_address2,
        setSAddress2,
        s_city,
        setSCity,
        s_country,
        setSCountry,
        s_postcode,
        setSPostcode,
        s_contactDescription,
        setSContactDescription,

        invoiceMethod,
        setInvoiceMethod,
        paymentMethod,
        setPaymentMethod,
        monthlyOverride,
        setMonthlyOverride,
        servicesCalculation,
        setServicesCalculation,
        tags,
        setTags,

        utr,
        setUtr,
        pc,
        setPc,
        cac,
        setCac,
        insurance,
        setInsurance,
        paye,
        setPaye,
        vat,
        setVat,
        auditLogs,
        setAuditLogs,

        officerIdStatus,
        setOfficerIdStatus,
        officerId,
        setOfficerId,

        accountsAndTaxCurrentYearDueDate,
        setAccountsAndTaxCurrentYearDueDate,
        accountsAndTaxNextYearDueDate,
        setAccountsAndTaxNextYearDueDate,

        currentMTDPeriodEnd,
        setCurrentMTDPeriodEnd,
        currentMTDPeriodDue,
        setCurrentMTDPeriodDue,

        VATFirstPeriod,
        setVATFirstPeriod,
        VATFrequency,
        setVATFrequency,
        VATCurrentPeriodEnd,
        setVATCurrentPeriodEnd,
        VATCurrentPeriodDueDate,
        setVATCurrentPeriodDueDate,
        isVatPresent,
        setVatPresent,

        CISDate,
        setCISDate,
        CISDueDate,
        setDueCISDate,
        CISFrequency,
        setCISFrequency,

        PAYEDate,
        setPAYEDate,

        payrollFrequency,
        setpayrollFrequency,
        payrollWeeklyDate,
        setPayrollWeeklyDate,
        payrollWeeklyDueDate,
        setPayrollWeeklyDueDate,
        payrollFortNightlyDate,
        setPayrollFortNightlyDate,
        payrollFortNightlyDueDate,
        setPayrollFortNightlyDueDate,
        payrollForWeeklyDate,
        setPayrollForWeeklyDate,
        payrollForWeeklyDueDate,
        setPayrollForWeeklyDueDate,
        payrollMonthlyDate,
        setPayrollMonthlyDate,
        payrollMonthlyDueDate,
        setPayrollMonthlyDueDate,

        bookkeepingFirstPeriodEnd,
        setBookkeepingFirstPeriodEnd,
        bookkeepingFrequency,
        setBookkeepingFrequency,
        bookkeepingCurrentPeriodEnd,
        setBookkeepingCurrentPeriodEnd,
        bookkeepingCurrentPeriodDueDate,
        setBookkeepingCurrentPeriodDueDate,
        isBookkeepingPresent,
        setBookkeepingPresent,

        managementAccountFirstPeriodEnd,
        setManagementAccountFirstPeriodEnd,
        managementAccountFrequency,
        setManagementAccountFrequency,
        managementAccountCurrentPeriodEndDate,
        setManagementAccountCurrentPeriodEndDate,
        managementAccountCurrentPeriodDueDate,
        setManagementAccountCurrentPeriodDueDate,
        isMAPresent,
        setMAPresent,

        confirmCurrentYearDueDate,
        setConfirmCurrentYearDueDate,
        confirmCSYearDueDate,
        setConfirmCSYearDueDate,

        currentKyc,
        setCurrentKyc,
        kycDuration,
        setKycDuration,
        nextKyc,
        setNextKyc,

        // maintain unsaved changes
        isChanged,
        setIsChanged,
      }}
    >
      {loading && <Loader />}

      {children}
    </ClientContext.Provider>
  )
}

export default ClientContextBox
